import { mapState } from 'vuex';

import { modalFormMixin } from '@/mixins/modalForm';

/**
 * Mixin do AsyncTree.vue
 *
 * @export
 * @param {*} moduleName Nazwa modułu
 * @param {*} messages Obiekt z powiadomieniami
 * @param {string} [propertyName='name'] Nazwa property do wyświetlenia, domyślnie 'name'
 * @param {*} resource - resource Moduły
 * @param {string} [childrenIdsName='childrenIds'] Nazwa pola z identyfikatorami węzłów podległych
 * @returns
 */
export function treeMixin(moduleName, messages, propertyName = 'name', resource, childrenIdsName = 'childrenIds') {
  function mapStructure(structure) {
    structure.isBatch = structure[childrenIdsName] && structure[childrenIdsName].length > 0;
    return structure;
  }

  function getChildren(node) {
    node.children = [];
    return resource.list({ parentId: node.id }).then(response => response.list.map(mapStructure));
  }

  return {
    mixins: [modalFormMixin(moduleName, messages)],
    data: () => ({
      nodeToUpdate: undefined,
      parentNode: undefined,
      parentId: undefined,
      options: {
        propertyNames: {
          text: propertyName
        },
        minFetchDelay: 0,
        fetchData: node => getChildren(node)
      },
      tree: undefined
    }),
    methods: {
      // @vuese
      // Dodaje Węzeł
      addNode(node) {
        this.parentId = node.id;
        this.parentNode = node;
        this.showAddModal();
      },
      // @vuese
      // Otwiera okienko z potwierdzeniem usunięcia
      showDeleteDialog(node) {
        this.$store.commit('showConfirm', {
          title: 'Usuwanie',
          description: `Czy na pewno chcesz usunąć węzeł: ${node.text}?`,
          onSuccess: () => this.remove(node)
        });
      },
      // @vuese
      // Chowa modal
      hideNodeModal() {
        this.parentId = undefined;
        this.hideModal();
      },
      // @vuese
      // Usuwa węzeł
      remove(node) {
        this.$store
          .dispatch(`${moduleName}/remove`, node.id)
          .then(() => {
            this.tree.remove(this.findNode(node));
            this.notifySuccess(messages.deleted);
          })
          .catch(err => this.notifyError(messages.deleteError));
      },
      // @Vuese
      // Przed update
      beforeUpdate(node) {
        this.nodeToUpdate = node;
        this.parentId = node.parent?.id;
        this.showEditModal(node.id);
      },
      // @vuese
      // Po update
      afterUpdate(data) {
        const node = this.findNode(this.nodeToUpdate);
        node.data.text = data[propertyName];
        this.nodeToUpdate = undefined;
      },
      // @vuese
      // Po add
      afterAdd(data) {
        if (this.parentNode && this.parentNode.id) {
          const parent = this.findNode(this.parentNode);
          if (parent.states.expanded) {
            parent.prepend({
              id: data.id,
              text: data.name,
              data
            });
          }
          parent.isBatch = true;
          parent.expand();
        } else {
          this.tree.prepend({
            id: data.id,
            text: data.name,
            data
          });
        }
        this.parentNode = undefined;
      },
      // @vuese
      // Szukanie noda
      findNode(node) {
        if (node.id) {
          return this.tree.findAll(node.data.text).filter(item => item.id === node.id)[0];
        } else {
          return this.tree;
        }
      },
      // @vuese
      // Ustawienie drzewa
      setTree(tree) {
        this.tree = tree;
      },
      // @vuese
      // Otwiera wszystkie obecne węzły
      expandAll() {
        this.tree.expandAll();
      }
    },
    computed: mapState({
      rootStructure: state => state[moduleName].list.map(mapStructure)
    })
  };
}
